var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.5H4C3.5875 7.5 3.25 7.8375 3.25 8.25C3.25 8.6625 3.5875 9 4 9H10C10.4125 9 10.75 8.6625 10.75 8.25C10.75 7.8375 10.4125 7.5 10 7.5ZM12.25 2.25H11.5V1.5C11.5 1.0875 11.1625 0.75 10.75 0.75C10.3375 0.75 10 1.0875 10 1.5V2.25H4V1.5C4 1.0875 3.6625 0.75 3.25 0.75C2.8375 0.75 2.5 1.0875 2.5 1.5V2.25H1.75C0.9175 2.25 0.25 2.925 0.25 3.75V14.25C0.25 15.075 0.9175 15.75 1.75 15.75H12.25C13.075 15.75 13.75 15.075 13.75 14.25V3.75C13.75 2.925 13.075 2.25 12.25 2.25ZM11.5 14.25H2.5C2.0875 14.25 1.75 13.9125 1.75 13.5V6H12.25V13.5C12.25 13.9125 11.9125 14.25 11.5 14.25ZM7.75 10.5H4C3.5875 10.5 3.25 10.8375 3.25 11.25C3.25 11.6625 3.5875 12 4 12H7.75C8.1625 12 8.5 11.6625 8.5 11.25C8.5 10.8375 8.1625 10.5 7.75 10.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a4df2798.svg";
export { ForwardRef as ReactComponent };